<p-panel *ngIf="jobInfo?.supplierId == organisationId || organisationTypeId == 1">
  <p-header>
    Carry-Over Authorisation
    <i
      class="fa fa-info-circle"
      [escape]="false"
      pTooltip="A Carry-Over is where authorisation has been given<br>for a vehicle to be kept overnight between collection and delivery"
    ></i>
  </p-header>
  <div class="ui-g">
    <div class="ui-g-12" style="max-height: 160px; overflow-y: auto">
      <p-table [value]="carryOverTasks">
        <ng-template pTemplate="body" let-data>
          <tr>
            <td
              style="
                width: 50px;
                vertical-align: middle;
                padding-left: 7px;
                padding-right: 7px;
                text-align: center;
              "
            >
              <p-checkbox
                [binary]="true"
                [disabled]="canChangeCarryOver(data)"
                (ngModelChange)="changeCarryOver(data)"
                [(ngModel)]="data.carryOverAuthorised"
              ></p-checkbox>
            </td>
            <td
              style="
                width: 110px;
                vertical-align: middle;
                padding-left: 7px;
                padding-right: 7px;
                text-align: center;
              "
            >
              <span class="carry-over-vrm">{{ data.vehicle.registrationNumber }}</span>
            </td>
            <td
              style="
                vertical-align: middle;
                padding-left: 7px;
                padding-right: 7px;
                text-align: center;
              "
            >
              <div>
                {{ data.taskSupplierSchedule?.specifiedPickUpTime | datex : 'HH:mm ddd DD' }}
                -
                {{ data.taskSupplierSchedule?.specifiedDropOffTime | datex : 'HH:mm ddd DD' }}
              </div>
            </td>
            <td
              style="
                width: 200px;
                vertical-align: middle;
                padding-left: 7px;
                padding-right: 7px;
                text-align: center;
              "
            >
              <div class="make-model">{{ data.vehicle.make }} {{ data.vehicle.model }}</div>
            </td>
            <td
              style="
                vertical-align: middle;
                padding-left: 7px;
                padding-right: 7px;
                text-align: center;
                width: 50px;
              "
              *ngFor="
                let overnightParkingPhotoTaskStep of data.overNightParkingPhotoTaskSteps;
                let i = index
              "
            >
              <a
                *ngIf="overnightParkingPhotoTaskStep.photoLocation"
                style="cursor: pointer"
                (click)="openPhotoPresigned(data.overNightParkingPhotoTaskSteps, i)"
              >
                <i class="material-icons">photo_camera</i>
              </a>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</p-panel>

<p-dialog
  [header]="(this.carryOverTask?.carryOverAuthorised ? 'Set' : 'Unset') + ' Carry-Over'"
  [(visible)]="showCarryOverDialog"
  [modal]="true"
  [style]="{ width: '460px' }"
  (onHide)="hideCarryOver()"
>
  <table style="margin-bottom: 10px">
    <tr>
      <td>Order:</td>
      <td>{{ carryOverTask?.order?.orderNumber }}</td>
    </tr>
    <tr>
      <td>Vehicle:</td>
      <td>
        <span class="carry-over-vrm">{{ carryOverTask?.vehicle?.registrationNumber }}</span> &nbsp;
        {{ carryOverTask?.vehicle?.make }} {{ carryOverTask?.vehicle?.model }}
      </td>
    </tr>
    <tr>
      <td>From:</td>
      <td>
        {{ carryOverTask?.pickupLocation?.postcode }} {{ carryOverTask?.pickupLocation?.city }} ({{
          carryOverTask?.taskSupplierSchedule?.specifiedPickUpTime | datex : 'ddd DD MMM HH:mm'
        }})
      </td>
    </tr>
    <tr>
      <td>To:</td>
      <td>
        {{ carryOverTask?.dropoffLocation?.postcode }}
        {{ carryOverTask?.dropoffLocation?.city }} ({{
          carryOverTask?.taskSupplierSchedule?.specifiedDropOffTime | datex : 'ddd DD MMM HH:mm'
        }})
      </td>
    </tr>
  </table>

  <textarea
    pInputTextarea
    [(ngModel)]="carryOverComment"
    placeholder="Enter note here"
    required
    style="width: 100%; height: 60px"
  ></textarea>

  <div class="text-right pt-2">
    <p-button label="Cancel" (click)="cancelCarryOver()"></p-button>
    <p-button
      label="Save"
      (click)="saveCarryOver()"
      [disabled]="carryOverComment.length == 0"
    ></p-button>
  </div>
</p-dialog>

<p-blockUI [blocked]="loadingPopupPhoto || isShownPopupPhoto">
  <img
    *ngIf="loadingPopupPhoto"
    src="assets/images/loader.gif"
    style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%)"
    width="50"
    height="50"
    alt="load"
  />
</p-blockUI>
<img
  *ngIf="isShownPopupPhoto"
  [src]="popupPhotoUrl"
  style="
    z-index: 10000;
    max-height: 90%;
    max-width: 90%;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  "
/>

<ngx-gallery
  *ngIf="showImage"
  [options]="overnightGalleryOptions"
  [images]="overnightImages"
  (previewClose)="onOverNightImagePreviewClose()"
></ngx-gallery>
